module.exports = __webpack_public_path__ + "111bcd9035672c307c29f7b69dc37376.fbx";